module.exports = __webpack_public_path__ + "static/media/tompgg.009f7a6b.gif";